import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DIALOG_MESSAGE_ID, DIALOG_TITLE_ID, DialogData, DialogResult } from './dialog.model';

@Component({
  selector: 'lib-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule],
})
export class DialogComponent {
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  readonly titleId = DIALOG_TITLE_ID;
  readonly messageId = DIALOG_MESSAGE_ID;

  private readonly dialogRef = inject<MatDialogRef<DialogComponent, DialogResult>>(MatDialogRef);

  onPrimaryClick(): void {
    this.dialogRef.close(DialogResult.Primary);
  }

  onSecondaryClick(): void {
    this.dialogRef.close(DialogResult.Secondary);
  }
}
